export const SUGGESTIONS_QUERY_KEY = ["eventDefinitionSuggestions"];
